import React from 'react';
import { useHistory } from 'react-router-dom';

const SubscriptionGuard = ({ children }) => {
  const history = useHistory();
  const User = JSON.parse(localStorage.getItem('User'));

  if (!User?.isSubscribed) {
    history.replace('/getting-started');
    return null;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default SubscriptionGuard;
